//NPM LIBRARIES
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import queryString from 'query-string';
import { Col } from 'reactstrap';
import { AUcallout } from '@gov.au/callout';
//REDUX ACTIONS AND SELECTORS
import {
    getFormDataSelector,
    getFormPropertiesSelector,
    getFormServiceStatusSelector,
} from '../FormStore/Selectors/FormDataSelectors';
import { SUBMISSION_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SubmissionAction';
import { industryAssistSubmission } from '../FormStore/Actions/FormServiceActions/IndustryAssist/SubmissionAction';
import { getB2cSettingsSelector } from '../PortalStore/Selectors/SystemSettingSelectors';
import {getCrmReferenceData} from '../FormStore/Actions/CRMReferenceDataActions';
import {addPageAlert, clearPageAlert} from '../PortalStore/Actions/PageAlertActions';
import { verifyIndustryAssistUser } from '../FormStore/Actions/FormServiceActions/IndustryAssist/VerifyIndustryAssitUserAction';
import { VERIFY_USER_ROLE_SUCCESS } from '../FormStore/Actions/FormServiceActions/IndustryAssist/VerifyUserRoleAction';

//COMPONENTS AND UTILITIES
import Application from '../components/CASAForm/Application';
import Step from '../components/CASAForm/Step';
import Question from '../components/CASAForm/Question';
import CASASpinner from '../components/Portal/CASASpinner';
import SuccessScreen from '../pages/SuccessScreen';

class IndustryAssist extends Component {
    constructor(props) {
        super(props);

        const urlParameters = this.processUrlParameters(window.location.search);

        this.state = {
            formLoaded: false,
            applicationSubmitting: false,
            organisationArn: urlParameters?.organisationArn ?? null,
            enableForm: false,
            organisationEmailAddress: '',
            link: urlParameters?.breadcrumbs[0].link
        }
    }

    componentDidMount() {
        this.props.dispatch(clearPageAlert());

        if (!this.state.formLoaded) {
            this.loadData();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.formProperties.submitForm &&
            prevProps.formProperties.submitForm !== this.props.formProperties.submitForm) {
            this.industryAssistSubmission()
        }
    }


    //toto - put in utils
    processUrlParameters = (windowUrl) => {
        let urlParameters = queryString.parse(windowUrl)
        if (urlParameters !== undefined) {            
            return JSON.parse(atob(decodeURIComponent(urlParameters.params)));            
        }
    }

    loadData = () => {
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;

        this.props.dispatch(
            verifyIndustryAssistUser(webappurlForms, this.props.b2cSettings.accesstokenForms, this.state.organisationArn))
        .then(response => {
            if (response.type === VERIFY_USER_ROLE_SUCCESS) {
                this.setState({
                    formLoaded: true,
                    enableForm: true,
                    organisationEmailAddress: response.payload.organisationEmailAddress
                });
            } else {
                this.setState({formLoaded: true, enableForm: false});
                this.props.dispatch(addPageAlert({
                    level: "error",
                    title: "Unable to complete application online",
                    message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                }));
            }
        })
        .catch(() => {
            this.props.dispatch(addPageAlert({
                level: "error",
                title: "Unable to complete application online",
                message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
            }));
            this.setState({formLoaded: true, enableForm: false});
        })
    }

    formStepNavigation = (direction) => {
        let currentStep = this.state.currentStep;

        if (direction === 'previous') {
            currentStep--
        } else if (direction === 'next') {
            currentStep++
        }

        this.setState({currentStep: currentStep})
    }

    industryAssistSubmission = () => {
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;
        this.setState({applicationSubmitting: true})

        if (this.props.formData) {
            this.props.dispatch(
                industryAssistSubmission(webappurlForms, this.props.b2cSettings.accesstokenForms, this.props.formProperties, this.props.formData)
            )
                .then(response => {
                    if (response.type === SUBMISSION_SUCCESS) {
                        this.setState({applicationSubmitting: false})
                        this.props.dispatch(addPageAlert({
                            level: 'success',
                            title: 'Documents successfully uploaded',
                            message: 'We have received your document submission.'
                        }));
                    } else {
                        this.setState({applicationSubmitting: false})
                        this.props.dispatch(addPageAlert({
                            level: "error",
                            title: "Unable to complete application online",
                            message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                        }));
                    }
                })
        }
    }

    render() {
        if (this.props.submissionStatus.submissionSucceeded) {
            return (
                <SuccessScreen>
                    <div>
                        <p>CASA will assess your documents shortly and may contact you if required to discuss your submission.
                            Confirmation of your submission has been sent to your organisation&apos;s email
                            address <strong>{this.state.organisationEmailAddress}</strong>.
                        </p>
                    </div>
                </SuccessScreen>
            )
        }
        return (
            <Fragment>
                {this.state.applicationSubmitting ? <CASASpinner message='Submitting form'/> : null}
                {this.state.formLoaded ?
                    <Application
                        formInformation={{
                            id: "industryAssistForm",
                            name: "Document and notification submission",
                            title: "Document and notification submission",
                            rootFormCode: "IA_DOCUMENT_SUBMISSIONS",
                            formCode: "IA_DOCUMENT_SUBMISSIONS_APPLICATION",
                            formDataType: "genericFormData",
                            version: "01"
                        }}
                        formActions={{
                            submit: this.submitForm
                        }}
                        enableSaveButton={false}
                        showback={false}
                        enableForm={this.state.enableForm}>

                        <Step
                            id="industryAssist"
                            stepTitle=""
                            nextStep={this.formStepNavigation}
                            initialStep
                            isLastStep
                            formSubmission={this.industryAssistSubmission}
                            showback={true}
                            backurl={this.state.link}
                            key="industryAssist">
                            
                            <Fragment>
                                <Col lg={6} md={6} className="float-none">
                                    <AUcallout
                                        title=""
                                        srOnlyTitle>
                                        <p>This function is for existing applications only. Do not lodge applications through this function unless you have been instructed by CASA to do so. 
                                            Please provide the correct reference number or case number that has been provided to you by CASA. If CASA has
                                            provided you with specific description text, please copy it into the Submission description field. </p>
                                    </AUcallout>
                                </Col>
                            </Fragment>

                            <Question
                                key="casaReference"
                                id="casaReference"
                                type="text"
                                label="CASA reference"
                                block={false}
                                stepid="industryAssist"
                                hintText="Please enter the CASA reference. If you do not know your CASA reference, <a href=&quot;https://www.casa.gov.au/about-us/contact-us&quot;>please contact CASA</a>."/>

                            <Question
                                key="submissionDescription"
                                id="submissionDescription"
                                type="textarea"
                                label="Submission description"
                                stepid="industryAssist"
                                minLength={50}
                                maximumlength={4000}
                                hintText="Please describe the documents you are submitting and any additional information relevant to your submission."
                                toolTip="Maximum 4000 characters and minimum 50 characters"/>

                            <Question
                                key="uploadDocuments"
                                id="uploadDocuments"
                                type="filePicker"
                                label="Upload documents"
                                stepid="industryAssist"
                                toolTip="You can upload up to ten files per submission. Accepted file types are PDF documents (.pdf), DOC documents (.doc, .docx) and Excel spreadsheets (.xls, .xslx)"
                                acceptedFiles=".pdf,.doc,.docx,.xls,.xlsx,.csv"
                                maxFileSize={62914}
                                errorMessages={{
                                    maxSizeReached: "The document exceeds the maximum file size of 60MB",
                                    invalidFileName: "Uploaded file name contains unsupported characters. Supported characters are alphabets, numbers and special characters , _ -. Please check the file you are trying to upload.",
                                    maxNoOfFilesReached: "The maximum of 10 documents have been reached",
                                    invalidFileType: "The file type is not supported"
                                }}
                                maxNoOfFilesAllowed={10}/>

                            <Question
                                id="declaration"
                                type="declaration"
                                name="declaration"
                                label="I agree and understand the above conditions."
                                value="declaration"
                                stepid="industryAssist" >
                                <div>
                                    <p>All statements in this application are true and correct in every particular and that I have read and understood all provisions of the Civil Aviation Safety Regulations 1998 which are relevant to this application.</p>
                                    <p>I understand CASA will use the currently held details to process this application and it is my responsibility to ensure my details are correct prior to lodgement.</p>
                                    <p>I consent to CASA using and disclosing my personal information in accordance with CASA Privacy Policy including exchanging the information with Commonwealth, State and Territory government agencies.</p>
                                    <p>I acknowledge that to knowingly make a false or misleading statement in this application is an offence against the Criminal Code Act 1995 (Cth).</p>
                                </div>
                            </Question>
                        </Step>
                    </Application> : <CASASpinner/>}
            </Fragment>
        );
    }
}

IndustryAssist.propTypes = {
    children: PropTypes.array,
    dispatch: PropTypes.func,
    smartform: PropTypes.object,
    b2cSettings: PropTypes.object,
    userdetails: PropTypes.object,
    submissionType: PropTypes.array,
    certificateTypes: PropTypes.array,
    casaRegion: PropTypes.array,
    formProperties: PropTypes.object,
    formData: PropTypes.object,
    submissionStatus: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        userdetails: state.userdetails,
        formProperties: getFormPropertiesSelector(state.formStore),
        formData: getFormDataSelector(state.formStore, 'genericFormData'),
        b2cSettings: getB2cSettingsSelector(state.B2CSettings, ['webappurlFormsApi', 'accesstokenForms', 'parsed']),
        submissionStatus: getFormServiceStatusSelector(state.formStore, 'submission')
    }
}

export default connect(mapStateToProps)(IndustryAssist);